import { Button } from "@glamcorner/components";
import React, { useEffect, useRef, useState } from "react";
import "./void-form.scss";

interface VoidFormProps {
  onSubmit: (data: { reason: string; note: string }) => void;
}

export const VoidForm: React.FC<VoidFormProps> = ({ onSubmit }) => {
  const reasonSelectRef = useRef(null);
  const noteTextareaRef = useRef(null);

  const [buttonEnabled, setButtonEnabled] = useState<boolean>(false);
  const [reason, setReason] = useState<string>("");
  const [note, setNote] = useState<string>("");

  const handleReasonChange = (event: any) => {
    setReason(event.target.value);
  };

  const handleNoteChange = (event: any) => {
    setNote(event.target.value);
  };

  useEffect(() => {
    if (reason) {
      if (reason === "other") {
        setButtonEnabled(!!note);
      } else {
        setButtonEnabled(true);
      }
    } else {
      setButtonEnabled(false);
    }
  }, [reason, note]);

  const handleButtonClicked = () => {
    onSubmit({ reason, note });
  };

  return (
    <div className="c-void-form">
      <h2>Void Refund Request</h2>
      <div className="c-void-form__form">
        <label htmlFor="void-form-reason" className="c-void-form__label">
          Reason
        </label>
        <select
          id="void-form-reason"
          className="c-void-form__select"
          onChange={handleReasonChange}
          ref={reasonSelectRef}
          value={reason}
        >
          <option/>
          <option value="duplicate">Duplicate</option>
          <option value="incorrect">Incorrect</option>
          <option value="ineligble">Ineligible</option>
          <option value="change-to-cash">Change to cash</option>
          <option value="change-to-credit">Change to store credit</option>
          <option value="other">Other (please specify in note)</option>
        </select>
        <label htmlFor="void-form-note" className="c-void-form__label">
          Note
        </label>
        <textarea
          id="void-form-note"
          className="c-void-form__textarea"
          onChange={handleNoteChange}
          ref={noteTextareaRef}
          value={note}
        />
        <Button onClick={handleButtonClicked} text="Void Refund Request" disabled={!buttonEnabled} />
      </div>
    </div>
  );
};
